import PositionsComponent from './PositionsComponent';
import WalletsComponent from './WalletsComponent';

export default function PortfolioStatusComponent({
  positions,
  updateRow,
  wallets,
  tokenBalances,
}) {
  return (
    <div>
      <PositionsComponent positions={positions} updateRow={updateRow} />
      <WalletsComponent wallets={wallets} tokenBalances={tokenBalances} />
    </div>
  );
}
